import axios from 'axios';
import authHeader from './auth-header';
import { API_URL } from './api-url';

class UserService {
  getAdminBoard() {
    return axios.get(API_URL + 'orders', { headers: authHeader() });
  }

  create(Order) {
    return axios.post(API_URL + 'admin/create', Order, { headers: authHeader() });
  }

  update(Order) {
    return axios.post(API_URL + 'admin/update', Order, { headers: authHeader() });
  }

  delete(Order) {
    return axios.post(API_URL + 'admin/delete', Order, { headers: authHeader() });
  }

  getComments(orderId){
    return axios.post(API_URL + 'orders/getallcomments', orderId, { headers: authHeader()})
  }

  createComment(comment){
    return axios.post(API_URL + 'moderator/createcomment', comment, { headers: authHeader()})
  }
}

export default new UserService();